module.exports = __webpack_public_path__ + "static/media/DIWALI_MAGAZINE_m_mr.04554428.jpg";